import styles from "./HowItsMade.module.scss";

/**
 * Product template — numbered manufacturing-process band (Figma `4669-18214` /
 * mobile `5596-20763`): eyebrow, heading, intro, then N bordered step cards each
 * led by a large coral numeral.
 *
 * The numeral is DERIVED from the item's position, not authored in the config, so
 * steps can be reordered or inserted without renumbering copy by hand.
 *
 * A step's `body` takes a string OR an array of strings — Figma renders steps 1
 * and 4 as two paragraphs each and steps 2 and 3 as one.
 */
export default function HowItsMade({
  eyebrow,
  heading,
  subheading,
  items = [],
  columns = 4,
  surface = "light",
}) {
  if (!items.length) return null;

  return (
    <section className={`${styles.section} ${styles[surface]}`}>
      <div className={styles.content}>
        {eyebrow && <p className={styles.eyebrow}>{eyebrow}</p>}
        {heading && <h2 className={styles.heading}>{heading}</h2>}
        {subheading && <p className={styles.subheading}>{subheading}</p>}

        <ol className={styles.grid} style={{ "--cols": columns }}>
          {items.map((item, i) => {
            const paras = Array.isArray(item.body)
              ? item.body
              : item.body
                ? [item.body]
                : [];

            return (
              <li className={styles.card} key={i}>
                <span className={styles.num}>{i + 1}.</span>
                <h3 className={styles.title}>{item.title}</h3>
                {paras.map((p, j) => (
                  <p className={styles.desc} key={j}>
                    {p}
                  </p>
                ))}
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
